import { authRoles } from 'app/auth';
import i18next from 'i18next';

import OptimizationPipelineLogEditForm from './editform/OptimizationPipelineLogEditForm';
import OptimizationPipelineLogTable from './table/OptimizationPipelineLogTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'optimizationPipelineLog', en);
i18next.addResourceBundle('hu', 'optimizationPipelineLog', hu);

export default [
	{
		path: '/optimization-pipeline-log/edit/:id/:tabKey?',
		component: OptimizationPipelineLogEditForm,
		auth: authRoles.optimizationPipelineLog
	},
	{
		path: '/optimization-pipeline-log/:sessionNameParam?',
		component: OptimizationPipelineLogTable,
		auth: authRoles.optimizationPipelineLog
	}
];